import { defineComponent as _defineComponent } from 'vue'
import { unref, computed } from 'vue';
    import ToggleListContent from '@ve/components/filters/common/components/toggleListContent/ToggleListContent.vue';
    import { useHotelDescriptionRepository } from '@entities/hotelDescription';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'HotelDescriptionFacilities',
  setup(__props) {

    const { hotelDescriptionFacilities } = useHotelDescriptionRepository();
    const isHotelDescriptionFacilitiesExists = computed(() => unref(hotelDescriptionFacilities).length > 0);

return { __sfc: true,hotelDescriptionFacilities, isHotelDescriptionFacilitiesExists, ToggleListContent }
}

})